var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorsClimbed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "floors-climbed_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.99 134.43"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".floors-climbed_svg__cls-2,.floors-climbed_svg__cls-4{fill:none;stroke:#344154;stroke-miterlimit:10;stroke-width:2.8px;stroke-linecap:round}.floors-climbed_svg__cls-4{stroke-width:2.2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 14.87a12.82 12.82 0 10-13.46 12.19A12.83 12.83 0 0073 14.87z",
    strokeWidth: 2.8,
    fill: "none",
    stroke: "#344154",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "floors-climbed_svg__cls-2",
    d: "M58.64 73.08L54.94 85l12.82 9.75A5.59 5.59 0 0170 99.17v24.55a6 6 0 01-6 6 6 6 0 01-6-6V105.4L38.6 92a11.59 11.59 0 01-5-9.51 11.83 11.83 0 01.32-2.72l8-33.21a11.45 11.45 0 0113.8-8.48 11.48 11.48 0 012.91 1.12 10.73 10.73 0 015.32 9.87",
    transform: "translate(0 -5.94)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "floors-climbed_svg__cls-2",
    d: "M55 45.83l14 18.22 10.53 2.44a4.23 4.23 0 013.17 5.11 4.23 4.23 0 01-5.1 3.14L66.48 72.1a6.36 6.36 0 01-3.6-2.35L49.39 51.83M33.46 60.45l-3 2.23-2.62 10.49a4.24 4.24 0 01-5.16 3.08 4.24 4.24 0 01-3.06-5.16l2.76-10.78a6.34 6.34 0 012.77-3.81l17-10.66M37.56 91.2l-3.24 11.36-19.79 6.88a5.65 5.65 0 00-4.36 6.77 5.66 5.66 0 006.8 4.28l26.22-8.27a4.41 4.41 0 003.26-3.13l2-10.23",
    transform: "translate(0 -5.94)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11.05a9 9 0 00-4.55 1.24 9.09 9.09 0 010 15.75A9 9 0 0060 29.27a9.11 9.11 0 100-18.22z",
    transform: "translate(0 -5.94)",
    fill: "#ff6d3b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "floors-climbed_svg__cls-4",
    d: "M112.44 96.19H77.98v37.01h9.22v-30.64h25.24M146.9 65.76h-34.46v37h9.22V72.12h25.24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.48,
    fill: "none",
    stroke: "#344154",
    strokeMiterlimit: 10,
    d: "M0 133.2h88.14"
  })));
}
export default SvgFloorsClimbed;